import React, { useState } from "react";
import { Button, Card, Typography, Spin, Alert } from "antd";
import {
  FileTextOutlined,
  DatabaseOutlined,
} from "@ant-design/icons";
import { request } from "../../functions/request";
import { Content } from "antd/es/layout/layout";
import { toast } from "react-toastify";

const { Title, Text } = Typography;

export default function ComexImportExportPreliminar() {
  const [isImporting, setIsImporting] = useState(false);
  const [importStatus, setImportStatus] = useState(null);

  const handleImportToDb = async () => {
    setIsImporting(true);
    setImportStatus(null);
    try {
      const response = await request("/comex-preliminar/import", { method: "POST" });
      if (response) {
        const hasErrors = response.results?.some((r) => r.error);
        const totalInserted = response.totalInserted || 0;
        if (hasErrors && totalInserted === 0) {
          setImportStatus({ type: "error", message: response.message || "Erro ao importar dados", totalInserted, filesProcessed: response.filesProcessed, results: response.results });
          toast.error("Erro na importação: nenhum registro inserido.");
        } else if (hasErrors) {
          setImportStatus({ type: "warning", message: response.message || "Importação concluída com avisos", totalInserted, filesProcessed: response.filesProcessed, results: response.results });
          toast.warning(`Importação com avisos: ${totalInserted} registros inseridos.`);
        } else {
          setImportStatus({ type: "success", message: response.message || "Importação concluída com sucesso", totalInserted, filesProcessed: response.filesProcessed, results: response.results });
          toast.success(`Importação concluída: ${totalInserted} registros inseridos!`);
        }
      } else {
        setImportStatus({ type: "error", message: "Erro ao importar dados para o banco", details: "Resposta inválida do servidor" });
        toast.error("Erro ao importar dados para o banco.");
      }
    } catch (error) {
      console.error("Erro ao importar para o banco:", error);
      setImportStatus({ type: "error", message: "Erro ao importar dados para o banco", details: error.message });
      toast.error("Erro ao importar dados para o banco. Tente novamente.");
    } finally {
      setIsImporting(false);
    }
  };

  // ========== RENDER PRINCIPAL ==========

  return (
    <Content style={{ padding: "24px" }}>
      <Card>
        <Title level={3}>
          <FileTextOutlined /> Comex Preliminar
        </Title>
        <Text type="secondary">
          Importação de dados preliminares de importação e exportação (Comex) ao banco de dados.
        </Text>

        <div style={{ marginTop: 16 }}>
          <Button
            type="primary"
            size="large"
            icon={<DatabaseOutlined />}
            loading={isImporting}
            onClick={handleImportToDb}
            danger
          >
            {isImporting ? "Importando..." : "Importar para o Banco de Dados"}
          </Button>
        </div>

        {isImporting && (
          <div style={{ textAlign: "center", marginTop: 24 }}>
            <Spin size="large" />
            <div style={{ marginTop: 16 }}>
              <Text>Processando importação... Isso pode levar alguns instantes.</Text>
            </div>
          </div>
        )}

        {importStatus && (
          <Alert
            message={importStatus.message}
            description={
              <div>
                {importStatus.totalInserted !== undefined && (
                  <p><strong>Total de registros inseridos:</strong> {importStatus.totalInserted.toLocaleString("pt-BR")}</p>
                )}
                {importStatus.filesProcessed !== undefined && (
                  <p><strong>Arquivos processados:</strong> {importStatus.filesProcessed}</p>
                )}
                {importStatus.results && importStatus.results.length > 0 && (
                  <div style={{ marginTop: 8 }}>
                    <strong>Detalhes:</strong>
                    <ul style={{ marginTop: 4, marginBottom: 0 }}>
                      {importStatus.results.map((result, idx) => (
                        <li key={idx}>
                          <strong>{result.file || result.name || `Item ${idx + 1}`}</strong>
                          {result.error ? (
                            <span style={{ color: "#ff4d4f" }}> - Erro: {result.error}</span>
                          ) : (
                            <span style={{ color: "#52c41a" }}> - {result.rows || 0} registro(s) inserido(s)</span>
                          )}
                        </li>
                      ))}
                    </ul>
                  </div>
                )}
                {importStatus.details && <p style={{ marginTop: 8 }}>{importStatus.details}</p>}
              </div>
            }
            type={importStatus.type}
            showIcon
            closable
            onClose={() => setImportStatus(null)}
            style={{ marginTop: 16 }}
          />
        )}
      </Card>
    </Content>
  );
}
